export default {
  filter: 'Filtre',
  btnReset: 'Réinitialisation',
  inputFrom: 'De',
  inputTo: 'À',
};
